import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';


class OtherDBDropDown extends React.Component {

    updateField(event) {
        if (event.target.value === '-1') {
            this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
        } else {
            this.props.updateAlOtherField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, parseInt(event.target.value));
        }
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    }

    render() {
        return (
            <select
                title={this.props.title}
                className={this.props.className}
                defaultValue={this.props.value ? this.props.value : -1}
                name={this.props.field}
                onChange={(event) => this.updateField(event)}
            >
                <option key={-1} value={-1}></option>

                { this.props.customOptions &&
                    Object.keys(this.props.customOptions)
                        .map(id => {
                            const option = this.props.customOptions[id];
                            return (
                                <option key={option.id} value={option.id}>{option.value}</option>
                            );
                        })
                }
            </select>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateAlOtherField: bindActionCreators(noteActions.updateAlOtherField, dispatch),
    };
}

function mapStateToProps(state, ownprops) {
    return {
        value: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field],
    };
}

const connectedOtherDBDropDown = connect(mapStateToProps, mapDispatchToProps)(OtherDBDropDown);
export { connectedOtherDBDropDown as OtherDBDropDown };